import { useEffect, useState } from 'react';

import { Environment } from '../constants/environments';
import { HttpVerb } from '../constants/httpVerbs';
import { ResaleListingGroup } from './contexts/resale-listing.context';
import { useApiService } from './useApiService';

interface UseResaleAvailabilityCheckResult {
  hasResale: boolean;
  loading: boolean;
}

export function useResaleAvailabilityCheck(
  eventId: number | undefined
): UseResaleAvailabilityCheckResult {
  const [hasResale, setHasResale] = useState(false);
  const [loading, setLoading] = useState(false);
  const { request } = useApiService();

  useEffect(() => {
    if (!eventId) {
      setHasResale(false);
      return;
    }

    let cancelled = false;

    const check = async () => {
      setLoading(true);
      try {
        const resourcePath = `/resale/event/${encodeURIComponent(String(eventId))}/grouped`
          + `?apikey=${Environment.API_KEY}`;
        const response = await request<null, { detail: { groups: ResaleListingGroup[] } }>(
          { requestOptions : { resourcePath }, type : HttpVerb.GET },
          { baseUrl : Environment.API_GATEWAY_URL }
        );
        if (!cancelled) {
          setHasResale((response?.detail?.groups ?? []).length > 0);
        }
      } catch {
        if (!cancelled) setHasResale(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    check();
    return () => { cancelled = true; };
  }, [eventId]);

  return { hasResale, loading };
}
